import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import s from './Drawer.css';

// position: 'right' | 'left' | 'top' | 'bottom'
function Drawer({ open, onClose, position = 'right', title, icon, children }) {
  const [visible, setVisible] = useState(false);
  const [animated, setAnimated] = useState(false);

  useEffect(() => {
    if (typeof document === 'undefined') return undefined;

    if (open) {
      setVisible(true);
      // Satu frame jeda agar browser render state awal sebelum transisi
      const raf = requestAnimationFrame(() => setAnimated(true));
      return () => cancelAnimationFrame(raf);
    } else {
      setAnimated(false);
      // Tunggu transisi selesai sebelum unmount
      const timer = setTimeout(() => setVisible(false), 350);
      return () => clearTimeout(timer);
    }
  }, [open]);

  useEffect(() => {
    if (typeof document === 'undefined') return undefined;
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  if (!visible || typeof document === 'undefined') return null;

  return ReactDOM.createPortal(
    <>
      <div className={cx(s.backdrop, { [s.backdropVisible]: animated })} onClick={onClose} />
      <div className={cx(s.drawer, s[position], { [s.open]: animated })}>

        <div className={s.drawerHeader}>
          {(title || icon) && (
            <h5 className={s.drawerTitle}>
              {icon && icon}
              {title}
            </h5>
          )}
          <button type="button" className={s.closeBtn} onClick={onClose} aria-label="Close">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18 17.94 6M18 18 6.06 6" />
            </svg>
          </button>
        </div>

        <div className={s.drawerBody}>
          {children}
        </div>

      </div>
    </>,
    document.body
  );
}

export default withStyles(s)(Drawer);
